import * as React from "react";
import Drawer from "@mui/material/Drawer";
import "./offer-dialog.scss";
import CloseIcon from "../../assets/close.svg";
import ExitIcon from "../../assets/exit.png"

const OfferPopUp = ({ isOpen, handleModalClose, offerDetail }) => {
  console.log(offerDetail);
  const offerImage = (type) => {
    switch (type) {
      case "percentage":
        return "%";
      case "flat":
        return "Flat";
      default:
        return null;
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  };

  const formatTime = (timeString) => {
    const [hour, minute] = timeString.split(':');
    let hourInt = parseInt(hour);
    const period = hourInt >= 12 ? 'PM' : 'AM';
  
    if (hourInt === 0) {
      hourInt = 12; // Midnight case
    } else if (hourInt > 12) {
      hourInt -= 12; // Convert to 12-hour format
    }
  
    const formattedHour = String(hourInt).padStart(2, '0');
    const formattedMinute = minute.padStart(2, '0');
  
    return `${formattedHour}:${formattedMinute} ${period}`;
  };

  const offerStartDate = formatDate(offerDetail?.startDate);
  const offerEndDate = formatDate(offerDetail?.endDate);
  const offerStartTime = formatTime(offerDetail?.startTime);
  const offerEndTime = formatTime(offerDetail?.endTime);

  return (
    <React.Fragment>
      <Drawer
        open={isOpen}
        anchor="bottom"
        classes={{
          paper: "div-border",
        }}
      >
        <div className="offer-dialog">
          {/* <div className="offerTitleSection" onClick={handleModalClose}>
            <div className="offerTitleText">Offer Details</div>
            <img className="offerExitIcon" src={ExitIcon} />
          </div> */}
          <div className="offerSubTitleSection">
            <div className="offerTitleSection">
              <div className="offerSubTitleText">
                {offerDetail.discountValue}
                {offerImage(offerDetail?.discountType)}
                {" OFF"}
              </div>
              <img className="offerExitIcon"  onClick={handleModalClose} src={ExitIcon} />
            </div>
           <div className="OfferSubTitleMiniText">No booking required</div>
           <div className="offerSubTitleContainer">
            <ul className="offerListPoints">
              <li><div className="offerListItems">{" Days Applicable : "}{offerDetail?.daysOfferApplicable}</div></li>
              <li><div className="offerListItems">{" Min. Bill Amount : "}<span>&#8377;</span>{offerDetail?.minOrderAmt}</div></li>
              <li><div className="offerListItems">{" Time : "}{offerStartTime} {" To "} {offerEndTime}</div></li>
              <li><div className="offerListItems">{" Start Date : "}{offerStartDate}</div></li>
              <li><div className="offerListItems">{" End Date : "}{offerEndDate}</div></li>
            </ul>
           </div>
          </div>
        </div>
      </Drawer>
    </React.Fragment>
  );
};

export default OfferPopUp;
